import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-circle-load-right",
  "use": "icon-si-glyph-circle-load-right-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-circle-load-right\" id=\"icon-si-glyph-circle-load-right\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>826</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0.04,7.379 C0.115,3.257 3.392,-0.033 7.344,0.042 C11.261,0.115 14.198,2.971 14.174,7.045 L15.719,7.045 C15.936,7.265 15.936,7.624 15.719,7.844 L13.873,9.86 C13.656,10.082 13.306,10.082 13.088,9.86 L11.363,7.844 C11.145,7.624 11.145,7.265 11.363,7.045 L12.785,7.045 C12.808,3.707 10.526,1.461 7.318,1.401 C4.085,1.339 1.406,4.031 1.343,7.403 C1.281,10.725 3.788,13.48 6.956,13.619 L6.956,14.98 C3.059,14.842 -0.035,11.46 0.04,7.379 L0.04,7.379 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-circle-load-right.svg
// module id = 5Vfo
// module chunks = 62